/* istanbul ignore file */
import React, { useRef, useEffect } from "react";
import { init, getInstanceByDom } from "echarts";
import type { CSSProperties } from "react";
import type { EChartsOption, ECharts, SetOptionOpts, } from "echarts";

export interface ReactEChartsProps {
    option: EChartsOption;
    style?: CSSProperties;
    settings?: SetOptionOpts;
    loading?: boolean;
    theme?: "light" | "dark";
}

export function ReactECharts({
                                 option,
                                 style,
                                 settings,
                                 loading,
                                 theme,
                             }: ReactEChartsProps): JSX.Element {
    const chartRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        // Initialize chart
        let chart: ECharts | undefined;
        if (chartRef.current !== null) {
            chart = init(chartRef.current, theme);
        }

        // Add chart resize listener
        // ResizeObserver is leading to a bit janky UX
        function resizeChart() {
            chart?.resize();
        }
        window.addEventListener("resize", resizeChart);

        // Return cleanup function
        return () => {
            chart?.dispose();
            window.removeEventListener("resize", resizeChart);
        };
    }, [theme]);

    useEffect(() => {
        // Update chart
        if (chartRef.current !== null) {
            const chart = getInstanceByDom(chartRef.current);
            if (!chart) return
            chart.setOption(option, settings);
            if (loading) {
                chart.showLoading()
            } else {
                chart.hideLoading()
            }
            requestAnimationFrame(() => {
                chart.resize();
            });
        }

    }, [option, settings, theme, loading]); // Whenever theme changes we need to add option and setting due to it being deleted in cleanup function

    return <div ref={chartRef} style={{ width: "100%", height: "300px", ...style }} />
}